const jQ = jQuery.noConflict();

function socialShare(url, width, height) {
    const left = (screen.width / 2) - (width / 2); //eslint-disable-line
    const top = (screen.height / 2) - (height / 2); //eslint-disable-line

    window.open(
        url,
        '',
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width },height=${height },top=${top },left=${left}`,
    );
}

function socialInit() {
    jQ('.container').on('click', '.share-link', function (e) { 
        e.preventDefault();
        socialShare(jQ(this).attr('href'), 500, 300);
    });
}

export default socialInit;
